<template>
  <div>
    <div class="w-full space-y-6">
      <h2 class="font-serif text-3xl font-bold text-center text-gray-900">Login</h2>

      <form @submit.prevent="submit" class="space-y-4">
        <input
          type="text"
          placeholder="Email or Phone Number"
          v-model="loginIdentifier"
          required
          class="form-input"
        />
        <input
          type="password"
          placeholder="Password"
          v-model="password"
          required
          class="form-input"
        />
        <button
          type="submit"
          class="btn-cream w-full py-3"
        >
          Login
        </button>
      </form>

      <div class="flex items-center justify-between gap-4">
        <button @click="$emit('switch','signup')" class="text-brand-red font-medium hover:underline text-sm">
          Create an Account
        </button>
        <button @click="$emit('switch','forgot')" class="text-brand-red font-medium hover:underline text-sm">
          Forgot Password?
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const emit = defineEmits(["success","error","switch"]);

const loginIdentifier = ref("");
const password = ref("");

const baseUrl = process.env.VUE_APP_API_BASE_URL || "https://sanskritirdapoon.in/api";

const submit = async () => {
  try {
    const res = await fetch(`${baseUrl}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: loginIdentifier.value, password: password.value }),
    });

    const data = await res.json();

    if (!res.ok) return emit("error", data.error || "Login failed!");

    localStorage.setItem("token", data.token);
    localStorage.setItem("user", JSON.stringify(data.user));

    emit("success","Login successful!");

    window.location.href = data.user.role === "admin"
      ? "/admin/dashboard"
      : "/";
  } catch {
    emit("error","Connection error");
  }
};
</script>
